// Öğretmen puanı (`zorluk_puan`) -> zorluk seviyesi: AD + RENK TEK KAYNAĞI.
//
// Sınıflandırma (öğretmen kararı, 2026-08-31):
//
//   1      hatalı   — revizelik. ZORLUK DEĞİL, tek kalite sinyali.
//   2-4    kolay
//   5-6    orta
//   7-9    zor
//   10     çok zor
//
// NEDEN TEK DOSYA: puan rozeti panelde ÜÇ ayrı yerde basılıyordu (App.js liste
// rozeti + grup çipleri, SoruKarti.js detay rozeti) ve puan verme butonları
// DÖRDÜNCÜ bir eşik seti kullanıyordu (<=3 kırmızı / <=6 sarı / gerisi yeşil).
// Hiçbiri diğeriyle uyuşmuyordu ve hiçbiri 1'i ayırmıyordu — 1 puanlı "hatalı"
// soru, 3 puanlı sağlam kolay soruyla aynı kırmızıydı. Yeni bir basım yeri
// eklenirse eşiği kopyalamak yerine buradan okur.
//
// RENK MANTIĞI (2026-09-23, kullanıcı kararı): puan rozeti ders etiketiyle aynı
// renge düşmesin diye zorluk TEK TON skalasıdır — gri koyulaştıkça zorlaşır
// (slate-500 kolay -> slate-900 çok zor). Kırmızı YALNIZ hatalı (1) içindir.
// Ders paleti (lib/dersler.js) gri/slate ve kırmızı KULLANMAZ; yeni ders rengi
// eklerken bu iki aileden kaçın.
//
// ⚠️ KAPSAM DIŞI: Basım sekmesindeki kova çipleri (components/Basim.js) bu
// dosyayı KULLANMAZ. Oradaki renk `backend/src/lib/denemeFormat.js` ZORLUK_KOVA
// sınırlarını (kolay 2-4 / orta 5-7 / zor 8-10) gösterir — yani sorunun hangi
// kovadan basılacağını. İki sınır seti 7 ve 10'da ayrışır; basım motoru bu
// sınıflandırmaya taşınırsa Basim.js de buraya bağlanır.

/** Bantlar — sıralı, kapsayıcı (min/max dahil). */
export const ZORLUK_SEVIYELERI = [
  // `filtreAd`: panel puan FİLTRESİNDE gösterilecek ad, `ad`dan farklıysa. 1 bandında
  // ikisi bilinçli ayrı: rozet sorunun DURUMUNU söyler ("hatalı"), filtre ise yapılacak
  // İŞİ ("revize") — öğretmen ikisini de bu anlamda kullandı (2026-08-31).
  { ad: 'hatalı',  filtreAd: 'revize', min: 1, max: 1, renk: '#DC2626', aktifSinif: 'bg-red-600 text-white border-red-700' },
  { ad: 'kolay',   min: 2,  max: 4,  renk: '#64748B', aktifSinif: 'bg-slate-500 text-white border-slate-600' },
  { ad: 'orta',    min: 5,  max: 6,  renk: '#475569', aktifSinif: 'bg-slate-600 text-white border-slate-700' },
  { ad: 'zor',     min: 7,  max: 9,  renk: '#1E293B', aktifSinif: 'bg-slate-800 text-white border-slate-900' },
  { ad: 'çok zor', min: 10, max: 10, renk: '#0F172A', aktifSinif: 'bg-slate-900 text-white border-black' },
];

/** Puansız/aralık dışı için açık gri (rozet zaten "Puan yok" der; "kolay" tonundan ayrı). */
export const ZORLUK_RENK_YOK = '#9CA3AF';

/** Puan -> bant nesnesi; puansız veya 1-10 dışıysa null. */
export function zorlukSeviye(puan) {
  const p = Number(puan);
  if (!Number.isFinite(p)) return null;
  return ZORLUK_SEVIYELERI.find(s => p >= s.min && p <= s.max) || null;
}

/** Puan -> rozet zemin rengi. */
export function puanRenk(puan) {
  const s = zorlukSeviye(puan);
  return s ? s.renk : ZORLUK_RENK_YOK;
}

/** Puan -> seviye adı ('hatalı' | 'kolay' | 'orta' | 'zor' | 'çok zor' | ''). */
export function puanSeviyeAdi(puan) {
  const s = zorlukSeviye(puan);
  return s ? s.ad : '';
}

/** Rozet/çip tooltip metni: "7/10 — zor". */
export function puanBaslik(puan) {
  const s = zorlukSeviye(puan);
  if (!s) return 'puan verilmedi';
  return s.ad === 'hatalı'
    ? '1/10 — hatalı soru (revize edilecek)'
    : `${puan}/10 — ${s.ad}`;
}

/**
 * Panel puan filtresi seçenekleri — bantlardan TÜRETİLİR, elle yazılmaz.
 * `value` doğrudan API'ye `?puan=` olarak gider; backend `puanWhere` bunu
 * `N` veya `N-M` deseni olarak ayrıştırır (sabit beyaz liste YOK — liste
 * tutulduğunda frontend'e eklenen yeni bant backend'de sessizce FİLTRESİZ
 * sonuç döndürüyordu).
 */
export const ZORLUK_FILTRE_SECENEKLERI = ZORLUK_SEVIYELERI.map((sv) => {
  const aralik = sv.min === sv.max ? `${sv.min}` : `${sv.min}-${sv.max}`;
  return { value: aralik, label: `${aralik} · ${sv.filtreAd || sv.ad}` };
});
